(function(){

  const FREE_SHIPPING_QTY = 3;
  const FREE_SHIPPING_THRESHOLD = 100;
  const FREE_SHIPPING_BTN_SELECTOR = "#free-shipping-btn";

  let lastDiscountQty = 0;

  const wrapper = document.getElementById("discount-progress-wrapper");
  const fill = wrapper?.querySelector(".progress-fill");
  const text = wrapper?.querySelector(".progress-text");

  if(!wrapper || !fill || !text) return;

  function fireConfetti(){
    if(window.confetti){
      confetti({ particleCount: 150, spread: 90, origin:{ y:0.7 }});
    }
  }

  /* ===========================================================
     ⭐ NEW → Get savings directly from DOM
     e.g. <div class="cart__savings">You're saving $36.87</div>
  ============================================================ */
  function getSavingsFromDOM() {
    const savingsEl = document.querySelector(".cart__savings");
    if (!savingsEl) return 0;

    const text = savingsEl.textContent.trim();
    const match = text.match(/\$([\d\.]+)/);

    return match ? parseFloat(match[1]) : 0;
  }

  /* ===========================================================
     ⭐ NEW → Correct subtotal = Shopify subtotal + savings
  ============================================================ */
  function getCorrectSubtotal(cart){
    const shopifySubtotal = cart.total_price / 100;  // default Shopify subtotal
    const savings = getSavingsFromDOM();             // from DOM

    return shopifySubtotal + savings;                // corrected total
  }

  function updateProgress(discountQty, totalQty, total) {
    let progress = 0;
    let message = "";

    // Discount progress
    if(discountQty >= 2){
      progress = 66;
      message = "🎉 Congratulations! You got 30% Discount!";
    } else if(discountQty === 1){
      progress = 33;
      message = "Add 1 more quantity of this product to get 30% Discount!";
    }

    // Free shipping incremental progress
    let shippingProgress = 0;
    let shippingMessage = "";

    if(totalQty >= FREE_SHIPPING_QTY && total >= FREE_SHIPPING_THRESHOLD){
      shippingProgress = 100;
      shippingMessage = "🎉 Free shipping unlocked!";
    } else if(totalQty >= FREE_SHIPPING_QTY){
      shippingProgress = 50 + ((total / FREE_SHIPPING_THRESHOLD) * 50);
      if(shippingProgress > 99) shippingProgress = 99;

      shippingMessage = `🎉 Discount Added! Add $${(FREE_SHIPPING_THRESHOLD - total).toFixed(2)} more to unlock free shipping!`;
    }

    const finalProgress = Math.max(progress, shippingProgress);
    fill.style.width = `${finalProgress}%`;

    text.textContent = shippingProgress >= progress ? shippingMessage : message;

    return (discountQty >= 2) || (totalQty >= FREE_SHIPPING_QTY && total >= FREE_SHIPPING_THRESHOLD);
  }

  function handleCart(cart) {

    // ⭐ Now subtotal includes your savings (DOM based)
    const total = getCorrectSubtotal(cart);

    const totalQty = cart.item_count;

    // find highest single product qty
    let discountQty = 0;
    cart.items.forEach(item => {
      if(item.quantity > discountQty){
        discountQty = item.quantity;
      }
    });

    const shouldFire = updateProgress(discountQty, totalQty, total);

    if((lastDiscountQty === 1 && discountQty === 2) || shouldFire){
      fireConfetti();
    }

    // Auto click free shipping button
    if(totalQty >= FREE_SHIPPING_QTY && total >= FREE_SHIPPING_THRESHOLD){
      const btn = document.querySelector(FREE_SHIPPING_BTN_SELECTOR);
      if(btn) btn.click();
    }

    lastDiscountQty = discountQty;
  }

  // Listen cart update event
  document.addEventListener("cart:updated", function(event){
    const cart = event.detail.cart;
    handleCart(cart);
  });

  // Initial load
  setTimeout(() => {
    fetch("/cart.js")
      .then(r => r.json())
      .then(cart => {
        handleCart(cart);
      });
  }, 300);

})();
